import { combineReducers } from 'redux';
import { popupReducer } from 'react-redux-popup';
import { routerReducer } from 'react-router-redux';
import tickets from 'noc/tickets/reducers';

export const resolve = reducerFunctions => (state = {}, action) => {
    const reducer = reducerFunctions[action.type];
    return reducer ? reducer(state, action) : state;
};

export default combineReducers({
    tickets: resolve(tickets),
    popup: popupReducer,
    routing: routerReducer
});


// WEBPACK FOOTER //
// ./app/reducers.js